import script from "./FormPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPagination.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__